import React from "react";

const NavigationTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: "blog-posts",
      label: "Blog Posts",
      isActive: activeTab === "blog-posts"
    },
    {
      id: "announcements",
      label: "Announcements",
      isActive: activeTab === "announcements"
    },
    {
      id: "roadmaps",
      label: "Roadmaps",
      isActive: activeTab === "roadmaps"
    },
    {
      id: "faqs",
      label: "FAQs",
      isActive: activeTab === "faqs"
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-1">
      <div className="flex space-x-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 px-4 py-3 text-sm font-medium rounded-md transition-all duration-200 ${
              tab.isActive
                ? "bg-secondary text-white shadow-sm"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationTabs;
